export enum EImportGoogleDriveStage {
  Uploaded,
  Saved,
  LogSaved,
}
